import { Col, Form, Input, Row, Select, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import {
  AutoComplete,
  
} from "antd";

const { Option } = Select;

const AddStreet = ({
  handleCancel,
  setReload,
  streetId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [suburbSearchList, setSuburbSearchList] = useState([]);
  const [countries, setCountries] = useState([]);
  //const [suburbList, setSuburbList] = useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  //const [weightList, setWeightList] = useState([]);
  const [states, setStates] = useState([]);

  const initialState = {
    street_name: "",
    country: authUserData()?.country ? authUserData()?.country : 1,
    state: authUserData()?.state ? authUserData()?.state : 1,
    suburb: null,
    zone: null,
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    getCountryName();
    authUserData()?.country ?
      getStateByCountry(authUserData()?.country) : getStateByCountry(1)
    authUserData()?.state ?
      getZoneByState(authUserData()?.state) : getZoneByState(1);

  }, []);
  useEffect(() => {
    const fetchzoneById = async () => {
      if (streetId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`street/${streetId}/`);
          if (response.data.success) {
            const {
              id,
              country_name,
              state_name,
              zone_name,
              suburb_name,
              state_code,
              country_code,
              ...filteredResponse
            } = response.data.data;
            setState((prevState) => {
              return {
                ...filteredResponse,
              };
            });

            formRef.current.setFieldsValue({
              ...response.data.data,
              state: response.data.data.state_name,
              country: response.data.data.country_name,
              zone: response.data.data.zone_name,
              suburb: response.data.data.suburb_name,
              street: response.data.data.street_name,

            });

            getStateByCountry(response?.data?.data?.country);
            getZoneByState(response?.data?.data?.state);
            getSuburbByzone(response?.data?.data?.zone)
            setapiLoading(false);
          }
        } catch (error) {
          console.error("Error fetching zone:", error);
          setapiLoading(false);
        }
      }
    };
    if (streetId !== null) {
      fetchzoneById();
    }
  }, [streetId, modalKey]);
  // const handleSuburbChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     suburb: value,
  //   }));
  // };
  const searchINBilling = async (value, id) => {
    const apiResponse = await getRequest(
      `suburb/?zone_id=${state.zone}&search_area=${value}`

    );

    if (apiResponse.data.results.success) {
      setSuburbSearchList(apiResponse.data.results.data);
    }
  };
  const onSearchBilling = async (value, id) => {

    setSearchValueBilling(value);
    value.length >= 3
      ? searchINBilling(!value ? null : value)
      : setSuburbSearchList([]);
    
  };

  const getCountryName = async () => {
    try {
      setapiLoading(true);
      const response = await getRequest("country/?no_pagination=True");
      const { data } = response.data;
      setCountries(data);
      formRef.current.setFieldsValue(response.data.data);
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  const handleCountrySelectChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleZoneChange = (value) => {
    // Find the zone name based on the selected zone id
    const selectedZone = zones.find((zone) => zone.id === value);
    const zoneName = selectedZone ? selectedZone.zone : "";

    // Update state and reset suburb/postcode lists
    setState((prevState) => ({
      ...prevState,
      zone: value,
      suburb: null,
    
  
    }));

    formRef.current.setFieldsValue({ suburb: null});
    //setSuburbList([]);
    setSuburbSearchList([]);
    //setWeightList([]);
  
    getWeightByZone(zoneName); // Pass the zoneName instead of the id
  };

  const handleSuburbSearchChange = (value) => {
    const selectedSuburb = suburbSearchList.find(option => option.id === value);
    if (selectedSuburb) {
      setState((prevState) => ({
        ...prevState,
        suburb: value, // Set the area name instead of ID
        postcode: null,
      }));

      formRef.current.setFieldsValue({ postcode: null, suburb: selectedSuburb.area });

    }
    if (selectedSuburb?.id) {
      getPostCodeBySuburb(selectedSuburb?.id);
    } else {
      console.log("error in suburb")
    }
  };

  const getSuburbByzone = async (id, value, suburb) => {
    try {
      setapiLoading(true);
      const suburbResponse = await getRequest(
        `suburb/?zone_id=${id}`
      );
     
      if (suburbResponse.data.results.success) {
        setSuburbSearchList(suburbResponse.data.results.data);
      }
      handleSuburbSearchChange();

    } catch {
      setapiLoading(false);
    }
  };

  const getPostCodeBySuburb = async (id) => {
    const pincodeResponse = await getRequest(
      "pincode/?no_pagination=true&suburb_id=" + id
    );
    const pincode = pincodeResponse?.data?.data.map((pincode) => ({
      id: pincode.id,
      name: pincode.pincode,
    }));
   
  };

  const getWeightByZone = async (zoneName) => {
    try {
      setapiLoading(true);

      const weightResponse = await getRequest(
        `delivery-rates/?state=${state.state}&zone=${zoneName}&no_pagination=true`
      );

      if (weightResponse.data.success) {
        //setWeightList(weightResponse?.data?.data);
      }

      setapiLoading(false);
    } catch {
      ErrorNotificationMsg(t("Error fetching suburb"));
      setapiLoading(false);
    }
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      zone: null,
      suburb: null
    }));
    formRef.current.setFieldsValue({ zone: null, suburb: null, });
    setZones([]);
    //setSuburbList([]);
    getZoneByState(value);
  };
  const getZoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };

  // const handlezoneChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     zone: value,
  //     suburb: null,
  //   }));
  //   formRef.current.setFieldsValue({ suburb: null });
  //   setSuburbList([]);
  //   getSuburbByzone(value);
  // };
 

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    authUserData()?.state ?
      getZoneByState(authUserData()?.state) : getZoneByState(1);
    setZones([]);
    handleCancel();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (streetId === null) {
        response = await postRequest("street/", state);
      } else {
        response = await patchRequest(`street/${streetId}/`, state);
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          streetId === null
            ? t("street_added_successfully")
            : t("street_updated_successfully")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);

        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form onFinish={handleSubmit} autoComplete="off" ref={formRef} initialValues={state}>
          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="country"
                label={t("pl_country")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_country")}</Trans>,
                  },
                ]}
              >
                <Select
                  placeholder={t("Select Country")}
                  name="country"
                  value={state?.country}
                  showArrow
                  showSearch
                  onChange={handleCountrySelectChange}
                  optionFilterProp="children"
                >
                  {countries.map((country) => (
                    <Option key={country.id} value={country.id}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="state"
                label={t("pl_state")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_state")}</Trans>,
                  },
                ]}
              >
                <Select
                  name="state"
                  label={t("pl_state")}
                  placeholder={"Select state"}
                  value={state?.state}
                  onChange={handleStateSelectChange}
                  showArrow
                  showSearch
                  optionFilterProp="children"
                >
                  {states.map((state) => (
                    <Option key={state.id} value={state.id}>
                      {state.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
          <Col xs={24} sm={12} md={12} lg={12} className="TextFeild">
                    <Form.Item
                      name="zone"
                      label={t("pl_zone")}
                      rules={[
                        {
                          required: true,
                          message: <Trans>{t("val_select_zone")}</Trans>,
                        },
                      ]}
                    >
                      <Select
                        placeholder={t("pl_select_zone")}
                        showArrow
                        showSearch
                        name="zone"
                        value={state?.zone}
                        optionFilterProp="children"
                        onChange={handleZoneChange}
                      >
                        {zones.map((zone) => (
                          <Option key={zone.id} value={zone.id}>
                            {zone.zone}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12} className="TextFeild">
                   
                    <Form.Item
                      name="suburb"
                      label={t("pl_suburb")}
                      rules={[
                        { 
                          required: true, 
                          message: 'Please select a suburb!' 
                        }
                      ]}
                    >
                      <AutoComplete
                        className="autoComplete"
                        onSearch={onSearchBilling}
                        value={state.suburb}
                        optionFilterProp="children"
                        allowClear
                        placeholder={t("pl_select_subrub")}
                        onChange={handleSuburbSearchChange}
                        disabled={!state.zone} 
                      >
                        {suburbSearchList.map((option) => (
                          <Option key={option.id} value={option.id}>
                            {option.area}
                          </Option>
                        ))}
                      </AutoComplete>
                    </Form.Item>
                  </Col>
          </Row>

          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="street_name"
                label={t("pl_street")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("pl_enter_street")}</Trans>,
                  },
                  {
                    validator(_, value) {
                      if (value && value.length > 100) {
                        return Promise.reject(
                          new Error("Maximum length of 100 characters exceeded")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder={t("enter_street")}
                  name="street_name"
                  value={state.street_name}
                  onChange={handleInputChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label={t("save")}
              htmlType="Submit"
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddStreet.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  streetId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func,
};

export default AddStreet;
